import CalendarIcon from "@/shared/assets/images/CalendarBlank.svg"
import DatePicker from "react-datepicker"
import { Select } from "@/shared/ui/select/select"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { selectDestType, selectEndDate, selectSelectedPartner, selectSocialMarketPartners, selectSocialMarketPartnersLoading, selectStartDate, setDestType, setEndDate, setSelectedPartner, setStartDate } from "../../model"
import { useMemo } from "react"

const destTypeSelectOptions = [
    {value: null, label: "Все типы"},
    {value: '1', label: "Сделка"},
    {value: '2', label: "Пополнение / Вывод"},
    {value: '3', label: "Комиссия"}
]

export const TransactionsFilters = () => {
    const dispatch = useAppDispatch()
    const partners = useAppSelector(selectSocialMarketPartners)
    const partner = useAppSelector(selectSelectedPartner)
    const startDate = useAppSelector(selectStartDate)
    const destType = useAppSelector(selectDestType)
    const endDate = useAppSelector(selectEndDate)
    const partnersLoading = useAppSelector(selectSocialMarketPartnersLoading)

    const partnersSelectOptions = useMemo(() => {
        return [
            { value: null, label: 'Все партнеры'},
            ...partners.map(partner => ({ value: partner.wallet_id, label: partner.name }))
        ]
    }, [partners])

    const handleDateChange = (data: [Date, Date]) => {
        const [start, end] = data
        dispatch(setStartDate(start))
        dispatch(setEndDate(end))
    }
    
    return (
        <div className="flex gap-4">
            <div className="w-full">
                <Select
                    value={destType}
                    placeholder="Тип операции"
                    onChange={(v) => dispatch(setDestType(v))}
                    options={destTypeSelectOptions}
                />
            </div>
            <div className="w-full">
                <Select
                    value={partner}
                    isLoading={partnersLoading}
                    placeholder="Партнер"
                    onChange={(v) => dispatch(setSelectedPartner(v))}
                    options={partnersSelectOptions}
                />
            </div>
            <div className="w-full min-w-[300px]">
                <DatePicker
                    selected={startDate}
                    startDate={startDate}
                    onChange={(dates) => handleDateChange(dates)}
                    endDate={endDate}
                    selectsRange
                    wrapperClassName="react-datepicker-filterlike"
                    dateFormat={"dd.MM.yyyy"}
                    showIcon
                    enableTabLoop={false}
                    popperProps={{
                        placement: 'bottom'
                    }}
                    icon={(<CalendarIcon width={24} height={24} />)}
                />
            </div>
        </div>
    )
}